"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BehaviorCodeReactionPossibleNextReactionsFilterDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const mappable_base_1 = require("../../mappable.base");
const enums_1 = require("../../enums");
class BehaviorCodeReactionPossibleNextReactionsFilterDto extends mappable_base_1.MappableBase {
    constructor(options) {
        super();
        if (!options)
            return;
        this.studentId = options.studentId;
        this.behaviorCodeId = options.behaviorCodeId;
        this.reactionType = options.reactionType;
    }
    behaviorCodeId;
    studentId;
    reactionType;
}
exports.BehaviorCodeReactionPossibleNextReactionsFilterDto = BehaviorCodeReactionPossibleNextReactionsFilterDto;
__decorate([
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], BehaviorCodeReactionPossibleNextReactionsFilterDto.prototype, "behaviorCodeId", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], BehaviorCodeReactionPossibleNextReactionsFilterDto.prototype, "studentId", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(enums_1.ReactionTypeEnum),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], BehaviorCodeReactionPossibleNextReactionsFilterDto.prototype, "reactionType", void 0);
